import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AddFoodCardFailureReasonDialogModule } from '@libs/shared/ui/dialogs/add-food-card-failure-reason-dialog';
import { ComplaintDialogModule } from '@libs/shared/ui/dialogs/complaint-dialog';
import { ConfirmationDialogModule } from '@libs/shared/ui/dialogs/confirmation-dialog';
import { DatepickerDialogModule } from '@libs/shared/ui/dialogs/datepicker-dialog';
import { DeleteWithTypeDialogModule } from '@libs/shared/ui/dialogs/delete-with-type-dialog';
import { LockExtensionDialogModule } from '@libs/shared/ui/dialogs/lock-extension-dialog';
import { PassFoodCardDialogModule } from '@libs/shared/ui/dialogs/pass-food-card-dialog';
import { ProfileImageCropperDialogModule } from '@libs/shared/ui/dialogs/profile-image-cropper-dialog';

@NgModule({
  imports: [
    ComplaintDialogModule,
    ConfirmationDialogModule,
    DatepickerDialogModule,
    LockExtensionDialogModule,
    PassFoodCardDialogModule,
    AddFoodCardFailureReasonDialogModule,
    ProfileImageCropperDialogModule,
    DeleteWithTypeDialogModule,
  ],
})
export class DialogModule {
  constructor(@Optional() @SkipSelf() parentModule?: DialogModule) {
    if (parentModule) {
      throw new Error(
        'FuseModule has already been loaded. Import this module in the AppModule only!'
      );
    }
  }
}
